import { render, staticRenderFns } from "./exchangeRate.vue?vue&type=template&id=6d2ed9bb&scoped=true"
import script from "./exchangeRate.vue?vue&type=script&lang=js"
export * from "./exchangeRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ed9bb",
  null
  
)

export default component.exports